// import { connect } from 'react-redux';
// import Table from './ApplicationTable';
import React, { createContext, useContext, useState, useEffect, useCallback, useRef, createRef  } from "react"
// import { CSVLink, CSVDownload } from "react-csv";
import Button from '@mui/material/Button';
// import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import Grid from '@mui/material/Grid';
import moment from 'moment';
// import DateFnsUtils from '@date-io/date-fns';
import DateFnsUtils from '@mui/lab/AdapterDateFns';
import ja from "date-fns/locale/ja";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import { Authentication } from '../../App'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { purple, red, grey } from '@mui/material/colors';
import Fab from '@mui/material/Fab';
import ReplyIcon from '@mui/icons-material/Reply';
import SendIcon from '@mui/icons-material/Send';
import styled from 'styled-components';
import makeStyles from '@mui/styles/makeStyles';
import Tooltip from '@mui/material/Tooltip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ClearIcon from '@mui/icons-material/Clear';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';




const authentication = require('react-azure-adb2c2').default;



export const ThemeContext = createContext();



// const useStyles = makeStyles({
//     contents: {
//     //   display: "flex",
//     //   alignItems: "center",
//       justifyContent: "space-between",
//     //   backgroundColor: "#ddd",
  
//       "&:hover": {
//         backgroundColor: "#eee",
  
//         "& $icon": {
//           display: "block",
//           position: "absolute", 
//           zIndex: 100, 
//           bottom: 0, 
//           right: 40
//         },
//       },
//     },
  
//     icon: {
//       display: "none",
//     },
//   });


const url = process.env.REACT_APP_API_CRM_URL
// const url = `http://localhost:5000`




export const YoyakuBuildingIndex= (props) => {

    const [myuserdetail, setMyUserDetail] = useState([]);//自分のユーザー情報
    const [userlist, setUserList] = useState([]);//ユーザーリスト

    const [meeting_category, setMeetingCategory] = useState([]);//meetingsのカテゴリ
    const [owner_id, setOwnerId] = useState([]);//owner_id
    const [eigyou_no, setEigyouNo] = useState([]);//eigyou_no
    const [meeting_detail, setMeetingDetail] = useState([]);//
    const [hs_meeting_id, setHsMeetingId] = useState(0);//
    const [reply_mode, setReplyMode] = useState(false);//
    const [comments, setComments] = useState("");
    const [edit_hs_meeting_detail_id, setEditMeetingDetailId] = useState(0);
    const [delete_modal, setDeleteModal] = useState(false);

    const [detail, setDetail] = useState({

        tatemono_id: "",
        no: 0,
        room_id: "",
        is_park: 0,
        park_bikou: "",
        reg_date: moment().format("YYYY-MM-DD"),
        is_renraku_zumi: 0,
        kokyaku_id: "",
        kokyaku_name: "",
        zip_1: "",
        zip_2: "",
        todoufuken: "",
        shikuchoson: "",
        choiki: "",
        other_address: "",
        tel: "",
        mail: "",
        renraku_bikou: "",
        gyousha_no: "",
        gyousha_name: "",
        gyousha_tel: "",
        gyousha_tantou: "",
        gyousha_bikou: "",
        bikou: "",
        user_id: 0,


    });//

    const [response_detail, setResponseDetail] = useState({});
    const [users, setUsers] = useState([]);
    const [user_detail, setUserDetail] = useState({});
    const [my_section_only, setMySectionOnly] = useState(true);

    const [tm_tatemono_list, setTmTatemonoList] = useState([]);
    const [tm_tatemono_detail, setTmTatemonoDetail] = useState({});
    const [tm_room_list, setTmRoomList] = useState([]);


    const token = authentication.getAccessToken();
    
      
    const getTatemonoDetailData = async (id) => {

        const f = await fetch(url + `/v1/tm/tatemono/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        

        if (!f.ok) {
            const errorData = await f.json();
            // throw new Error(errorData.message || 'APIエラーが発生しました');
            alert("失敗しました")
        }else{
            const d = await f.json()
            setTmTatemonoDetail(d)
        }
    }

    const getTatemonoListData = async () => {

        const f = await fetch(url + `/v1/tm/tatemono/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        // 

        if (!f.ok) {
            const errorData = await f.json();
            // throw new Error(errorData.message || 'APIエラーが発生しました');
            alert("失敗しました")
        }else{
            const d = await f.json()

            setTmTatemonoList(d)
        }
    }

    const getRoomListData = async (id) => {

        const f = await fetch(url + `/v1/tm/room/list/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        // 

        if (!f.ok) {
            const errorData = await f.json();
            // throw new Error(errorData.message || 'APIエラーが発生しました');
            alert("失敗しました")
        }else{
            const d = await f.json()

            let newTmRoomList = [...tm_room_list]
            setTmRoomList(newTmRoomList.concat(d))
        }
    }

    //保存
    const onSave = async() => {
        if(detail.no != ""){
            // update
            updateDetail(detail)
        }else{
            insertDetail(detail)
        }
    }

    //新規
    const insertDetail = async(detail) => {

        var f = await fetch(url+`/v1/t/yoyaku/insert`, { method: 'post', body: JSON.stringify(detail), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })

        if (!f.ok) {
            const errorData = await f.json();
            alert("失敗しました")
        }else{
            const d = await f.json()
            props.onClose(d)
        }

    };

    //更新
    const updateDetail = async(detail) => {

        var f = await fetch(url+`/v1/t/yoyaku/update`, { method: 'post', body: JSON.stringify(detail), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        
        if (!f.ok) {
            const errorData = await f.json();
            alert("失敗しました")
        }else{
            const d = await f.json()
            props.onClose(d)
        }

    };

    useEffect(() => {
        setResponseDetail(props.responsedetail)
        setUserDetail(props.user_details)
        setUsers(props.users)

        let newdetail = {...detail};

        newdetail = props.detail
        // newdetail.tatemono_id = props.detail.tatemono_id
        // newdetail.room_id = props.detail.room_id
        // newdetail.user_id = props.detail.user_id

        setDetail(newdetail)

        if(props.detail.tatemono_id){
            getTatemonoDetailData(props.detail.tatemono_id)
            getRoomListData(props.detail.tatemono_id)
        }

        getTatemonoListData()

    }, [props])
   


    // const classes = useStyles();



    return (
        <>
        <DialogContent style={{ background: "#e9f2f8" }}>

            <Box sx={{width:"100%", backgroundColor:"white", p:1, mt:1}}>
                <div style={{display:"flex", }}>
                    <Typography variant="h6" gutterBottom sx={{flex:1}}>
                    基本情報
                    </Typography>

                    <div sx={{flex:1}}>
                        <FormControlLabel control={<Checkbox size="small"/>} label="連絡済み" 
                            onChange={(e)=>setDetail(prevDetail => ({
                                ...prevDetail,
                                is_renraku_zumi: e.target.checked,
                            }))}
                            componentsProps={{ typography: { sx: { fontSize: "14px" } } }} checked={detail.is_renraku_zumi == true ? true : false}
                        />
                    </div>
                </div>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                    <TextField
                        sx={{ width: 150 }} 
                        type='date'
                        label="受付日" 
                        size="small" 
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                        value={moment(detail.reg_date).format("YYYY-MM-DD")}
                        error={!detail.reg_date}
                        onChange={(e) => {
                            setDetail(prevDetail => ({
                                ...prevDetail,
                                date: e.target.value
                            }));
                        }}
                    />
                    <div style={{display:"flex"}}>
                        <Autocomplete
                            options={users && user_detail ? my_section_only ? users.filter(a=>a.amSectionId == user_detail.amSectionId): users :[]}
                            getOptionLabel={(option) => option.userNameAll ? option.userNameAll : ''}
                            value={users.length > 0 && detail.user_id > 0 ? users.filter(a => a.id === parseInt(detail.user_id))[0] : {}}
                            size='small'
                            sx={{width:"170px",fontSize:"14px"}}
                            onChange={(event, newValue) => {
                            if (newValue) {
                                setDetail(prevDetail => ({
                                ...prevDetail,
                                user_id: newValue.id
                                }));
                            }
                            }}
                            renderInput={(params) => <TextField  
                            {...params} label="担当を選択" fullWidth InputLabelProps={{ shrink: true }} />}
                        />
                            <FormControlLabel sx={{pl:2}}
                                control={<Checkbox defaultChecked size="small" sx={{'&.Mui-checked': {color: '#f50057',}}}/>} label="自店のみ" 
                                componentsProps={{ typography: { sx: { fontSize: "14px" } } }} disabled={detail.completed_at}
                                checked={my_section_only} onChange={(e)=>setMySectionOnly(e.target.checked)} name="my_section_only"
                            />
                    </div>


                </Box>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                
                    <div style={{marginTop:5}}>
                        {/* <span style={{fontSize:"16px", marginRight:5}}>{tm_tatemono_detail.tatemono_name}</span> */}
                        <Autocomplete
                            options={tm_tatemono_list ? tm_tatemono_list :[]}
                            
                            getOptionLabel={(option) => option.Tatemono_Name ? option.Tatemono_Name : ''}
                            isOptionEqualToValue={(option, value) => option.Tatemono_Id === value.Tatemono_Id}
                            value={tm_tatemono_list.length > 0 && detail.tatemono_id ? tm_tatemono_list.find(a => a.Tatemono_Id === detail.tatemono_id) : {}}
                            size='small'
                            sx={{width:"250px",fontSize:"14px"}}
                            onChange={(event, newValue) => {
                            if (newValue) {
                                setDetail(prevDetail => ({
                                ...prevDetail,
                                tatemono_id: newValue.Tatemono_Id
                                }));
                            }
                            }}
                            renderInput={(params) => <TextField  
                            {...params} label="建物選択" fullWidth InputLabelProps={{ shrink: true }} />}
                        />

                    </div>
                    <div style={{marginTop:5}}>

                        <FormControl variant="outlined" size="small" sx={{ width: 170 }}>
                        {/* ラベルの id と Select の labelId は同じにする */}
                        <InputLabel id="room-select-label" shrink={true}>部屋選択</InputLabel>

                        <Select
                            labelId="room-select-label"
                            id="room-select"
                            label="部屋選択"              // ← 重要: Select にも同じラベル文字列を指定
                            value={detail.room_id}
                            // InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                            setDetail(prevDetail => ({
                                ...prevDetail,
                                room_id: e.target.value
                            }));
                            }}
                            displayEmpty              // displayEmptyが必要なら残す
                        >
                            {/* 空選択などが欲しい場合はこんな形で書いておく */}
                            <MenuItem value="">
                            <em>指定なし</em>
                            </MenuItem>

                            {/* 部屋リストをマップ */}
                            {tm_room_list.map((item) => (
                            <MenuItem key={item.room_id} value={item.room_id}>
                                {item.room_name}({item.room_id})
                            </MenuItem>
                            ))}
                        </Select>
                        </FormControl>
                        
                    </div>

                    <FormControlLabel control={<Checkbox size="small"/>} label="要駐車場" 
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            is_park: e.target.checked,
                        }))}
                        componentsProps={{ typography: { sx: { fontSize: "14px" } } }} checked={detail.is_park == true ? true : false}
                    />
                </Box>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                    <TextField
                        fullWidth
                        label="備考"
                        type="text"
                        name="park_bikou"
                        multiline
                        minRows={2}
                        maxRows={4}
                        value={detail.park_bikou}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // variant="standard"
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            park_bikou: e.target.value
                        }))}

                    />
                </Box>
            </Box>
            <Box sx={{width:"100%", backgroundColor:"white", p:1, mt:1}}>
                <Typography variant="h6" gutterBottom>
                予約者情報
                </Typography>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                    <TextField
                        label="名前"
                        type="text"
                        name="kokyaku_name"
                        value={detail.kokyaku_name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // variant="standard"
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            kokyaku_name: e.target.value
                        }))}
                        size="small"
                        style={{width:"40%"}}
                    />
                </Box>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                    <TextField
                        label="電話番号"
                        type="text"
                        name="tel"
                        value={detail.tel}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // variant="standard"
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            tel: e.target.value
                        }))}
                        size="small"
                        style={{width:"40%"}}
                    />
                    <TextField
                        label="メール"
                        type="text"
                        name="mail"
                        value={detail.mail}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // variant="standard"
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            mail: e.target.value
                        }))}
                        size="small"
                        style={{width:"50%"}}
                    />
                </Box>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                    <TextField
                        fullWidth
                        label="備考"
                        type="text"
                        name="renraku_bikou"
                        multiline
                        minRows={2}
                        maxRows={4}
                        value={detail.renraku_bikou}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // variant="standard"
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            renraku_bikou: e.target.value
                        }))}

                    />
                </Box>
            </Box>
            <Box sx={{width:"100%", backgroundColor:"white", p:1, mt:1}}>

                <Typography variant="h6" gutterBottom>
                    仲介業者情報
                </Typography>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                    <TextField
                        label="業者名"
                        type="text"
                        name="gyousha_name"
                        value={detail.gyousha_name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            gyousha_name: e.target.value
                        }))}
                        size="small"
                        style={{width:"40%"}}
                    />
                </Box>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                    <TextField
                        label="業者担当者"
                        type="text"
                        name="gyousha_tantou"
                        value={detail.gyousha_tantou}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // variant="standard"
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            gyousha_tantou: e.target.value
                        }))}
                        size="small"
                        style={{width:"40%"}}
                    />
                    <TextField
                        label="業者電話番号"
                        type="text"
                        name="gyousha_tel"
                        value={detail.gyousha_tel}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // variant="standard"
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            gyousha_tel: e.target.value
                        }))}
                        size="small"
                        style={{width:"50%"}}
                    />
                </Box>
                <Box gap={5} sx={{display:"flex", pt:1, pl:5}} >
                    <TextField
                        fullWidth
                        label="備考"
                        type="text"
                        name="gyousha_bikou"
                        multiline
                        minRows={2}
                        maxRows={4}
                        value={detail.gyousha_bikou}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // variant="standard"
                        onChange={(e)=>setDetail(prevDetail => ({
                            ...prevDetail,
                            gyousha_bikou: e.target.value
                        }))}

                    />
                </Box>
            </Box>

        </DialogContent>
        <DialogActions>
            <Button variant="contained" disabled={!detail.tatemono_id} color="primary" sx={{marginRight:1}} onClick={onSave}>保存</Button>
            <Button variant="contained" style={{backgroundColor: '#6c757d', border:"1px solid #919191"}} onClick={props.onClose}>閉じる</Button>
        </DialogActions>

        </>
    );
}



export default YoyakuBuildingIndex;